import { ConfirmModal } from '@safetyhub/ui';

type TemplatePublishModalProps = {
  /** 적용할 다음 공개 상태 — true=공개(활성화), false=비공개(비활성화). null이면 닫힘. */
  next: boolean | null;
  /** PATCH 진행 중 — 확인 버튼 비활성(중복 클릭 방지). */
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * 템플릿 "공개(enabled)" 토글의 양방향 확인 모달 — 공용 [[ConfirmModal]] 위의 문구 분기다.
 * - next=true(공개): 일반 사용자에게 노출되어 보고서 작성에 사용 가능해짐을 안내.
 * - next=false(비공개): 신규 작성 차단 + 기존 보고서 영향 없음을 안내.
 * - 오버레이/Esc/취소=onCancel, 확인=onConfirm(요청 중엔 disabled).
 *
 * danger로 두지 않는다 — 양방향 모두 되돌릴 수 있고(다시 토글) 기존 보고서를 건드리지 않아
 * 파괴적이지 않다. 따라서 default 액션은 규약대로 **확인**(자동 포커스).
 * 이관 전 확인 버튼의 초록/회색 자가 채색은 버렸다 — 버튼 시각은 프리미티브가 소유한다.
 */
export function TemplatePublishModal({ next, busy, onConfirm, onCancel }: TemplatePublishModalProps) {
  const activating = next === true;

  return (
    <ConfirmModal
      open={next !== null}
      title={activating ? '템플릿 공개' : '템플릿 비공개 전환'}
      body={
        activating
          ? '이 템플릿이 일반 사용자에게 공개되어 보고서 작성에 사용할 수 있게 됩니다. 공개할까요?'
          : '일반 사용자의 보고서 타입 선택지에서 숨겨지고 신규 작성이 차단됩니다. 이미 작성된 보고서는 영향받지 않습니다. 비공개로 전환할까요?'
      }
      confirmLabel={activating ? '공개' : '비공개 전환'}
      busy={busy}
      onConfirm={onConfirm}
      onClose={onCancel}
    />
  );
}
